export const formatDateString = (dateString: string) => {
    return dateString?.substring(0,16).replace('T', ' ');
}